export class SendMessageFromSurveyActionSettings {
    constructor() { }
}
